<template>
  <div class="frisbuy-preview-close-button" @click="$emit('click')"></div>
</template>

<style scoped lang="scss">
$shadowColor: rgba(34, 60, 80, 0.5);

.frisbuy-preview-close-button {
  position: relative;

  width: 17px;
  height: 17px;

  background-color: transparent;

  cursor: pointer;

  &:before {
    transform: rotate(-45deg);
  }

  &:after {
    transform: rotate(45deg);
  }

  &:before,
  &:after {
    position: absolute;
    top: -8%;
    left: 50%;

    background-color: #fff;
    box-shadow: 0px 0px 0px 1px $shadowColor;

    width: 2px;
    height: 125%;

    content: "";
  }
}
</style>

<script>
export default {
  $emits: ["click"],

  data() {
    return {};
  },
};
</script>
